import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { CommentableType } from '@utils/backend-api/comments';

import CommentsContent from './Content';

const queryClient = new QueryClient();

interface CommentsProps {
  commentableId: number;
  commentableType: CommentableType;
  commentCount?: number;
}

const Comments = ({ commentableId, commentableType, commentCount }: CommentsProps) => (
  <QueryClientProvider client={queryClient}>
    <CommentsContent
      commentableId={commentableId}
      commentableType={commentableType}
      commentCount={commentCount}
    />
  </QueryClientProvider>
);

export default Comments;
